import React from "react";
import Selectcategory from "../../../../assets/images/tot/selectcat.png";
import TrippleArrows from "../../../../assets/images/teambuilding.png";

const SelectCategory = ({ buttonData, selectedIndex, onClickItem, type }) => {
  return (
    <div className="select-cateory-content">
      <div className="select-list">
        {type === "tot" ? (
          <img src={Selectcategory} className="mb-4" />
        ) : (
          <h3>Select Category</h3>
        )}
        {buttonData.map((item, index) =>
         (
          <div>
            <button
              key={item.title}
              onClick={() => onClickItem(index)}
              className={selectedIndex === index && "active"}
            >
              {item.title}
            </button>
          </div>
        ))}
      </div>
      <span className="poweredby">
        <label>Content Provided By </label>
        <img src={TrippleArrows} />
      </span>
    </div>
  );
};

export default SelectCategory;
